export default {
  rollIsMax(roll) {
    return roll.rollData.total == roll.rollData.maxTotal;
  },
  rollIsMin(roll) {
    return roll.rollData.total == roll.rollData.minTotal;
  },
}
